import ptBr from './pt-br';
import enGB from './en-gb';
import enUS from './en-us';
import es from './es';
import esMX from './es-mx';

export default {
  'pt-br': ptBr,
  es,
  'en-GB': enGB,
  'en-US': enUS,
  'es-MX': esMX,
};
